export default __webpack_public_path__ + "static/media/organization.b729aa2f.svg";